var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;



//////////////////
// WEBPACK FOOTER
// ./~/victory-cursor-container/~/lodash/_mapCacheGet.js
// module id = ./node_modules/victory-cursor-container/node_modules/lodash/_mapCacheGet.js
// module chunks = 1